
const items = [
    {
        id: '1',
        name: 'عدد',
        preName: 'تعداد'
    },
    {
        id: '2',
        name: 'بسته',
        preName: 'تعداد'
    },
    {
        id: '3',
        name: 'کارتن',
        preName: 'تعداد'
    },
    {
        id: '4',
        name: 'گرم',
        preName: 'مقدار'
    },
    {
        id: '5',
        name: 'کیلو گرم',
        preName: 'مقدار'
    },
    {
        id: '6',
        name: 'تن',
        preName: 'مقدار'
    },
    {
        id: '7',
        name: 'بشکه',
        preName: 'تعداد'
    },
    {
        id: '8',
        name: 'باکس',
        preName: 'تعداد'
    },
    {
        id: '9',
        name: 'لیتر',
        preName: 'مقدار'
    },
    {
        id: '10',
        name: 'دستگاه',
        preName: 'تعداد'
    },
    {
        id: '11',
        name: 'متر',
        preName: 'مقدار'
    },
    {
        id: '12',
        name: 'ورق',
        preName: 'تعداد'
    },
    {
        id: '13',
        name: 'نسخه',
        preName: 'تعداد'
    },
    {
        id: '14',
        name: 'شاخه',
        preName: 'تعداد'
    },
    {
        id: '15',
        name: 'بطری',
        preName: 'تعداد'
    },
    {
        id: '16',
        name: 'سرویس',
        preName: 'تعداد'
    },
    {
        id: '17',
        name: 'شانه',
        preName: 'تعداد'
    },
]

const getUnits = () => {
    return [...items]
};

export default getUnits;